// RentTrackerPage.tsx - Page wrapper for Rent Tracker tool
import React from 'react';
import RentTracker from '../../components/rent-tracker/RentTracker';
import { useAuth } from '../../auth/firebaseAuth';
import { Navigate } from 'react-router-dom';
import { isLandlord, isAgentOrisLandlord } from '../../types/userTypes';
import LandlordToolkitLayout from '../../components/landlord-toolkit/LandlordToolkitLayout';

const RentTrackerPage: React.FC = () => {
  const { currentUser, userProfile } = useAuth();

  // Redirect if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Only landlords and agents should access this tool
  if (
    userProfile &&
    !isLandlord(userProfile) &&
    !isAgentOrisLandlord(userProfile)
  ) {
    return (
      <div className="container mx-auto px-4 py-16 text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Access Restricted
        </h1>
        <p className="text-gray-600 mb-8">
          This tool is only available to landlords and property agents.
        </p>
        <a
          href="/landlord-dashboard"
          className="px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
        >
          Go to Dashboard
        </a>
      </div>
    );
  }

  return (
    <LandlordToolkitLayout title="Rent Tracker">
      <div className="mb-8">
        <p className="text-lg text-gray-600">
          Manage rent payments, track overdue rents, and communicate with your
          tenants.
        </p>
      </div>
      <RentTracker />

      {/* Information section */}
      <div className="mt-12 bg-blue-50 border border-blue-200 rounded-lg p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          About Rent Tracker
        </h2>
        <div className="space-y-3 text-gray-700">
          <p>
            <strong>✓ Track Payments:</strong> Monitor all rent payments across
            your properties in one place.
          </p>
          <p>
            <strong>✓ Automatic Reminders:</strong> Our system automatically
            sends reminders to tenants for upcoming and overdue payments.
          </p>
          <p>
            <strong>✓ Payment History:</strong> Keep a complete record of all
            rent payments and transactions.
          </p>
          <p>
            <strong>✓ Broadcast Messages:</strong> Send important updates to all
            tenants in a property with one click.
          </p>
        </div>
      </div>
    </LandlordToolkitLayout>
  );
};

export default RentTrackerPage;
